module.exports = __webpack_public_path__ + "img/Enjoy-Having-My-Good-Friends-With-Me.58d04277.jpg";